export default __webpack_public_path__ + "static/media/anthem-invite-image.55b9500c.gif";